import Http from '@/utils/request'

export function getData(params) {
  return Http.get({
    url: '/test/getData',
    params,
  })
}

export function postData(data) {
  return Http.post({
    url: '/test/postData',
    data,
  })
}

export function postJsonData(data) {
  return Http.postJson({
    url: '/test/postJsonData',
    data,
  })
}

export function postFileData(data) {
  return Http.postFile({
    url: '/test/postFileData',
    data,
    responseType: 'blob',
  })
}

/* 公共 */
// 登录
export function login(params) {
  return Http.get({
    url: '/cms/user/login',
    params,
  })
}

// 登出
export function logout(params) {
  return Http.get({
    url: '/cms/user/logout',
    params,
  })
}

// 上传图片
export function uploadfile(data) {
  return Http.postFile({
    url: '/analyzer/admin/modules/fileupload/uploadfile',
    data,
    responseType: 'blob',
  })
}

// 上传多个图片
export function uploadfiles(data) {
  return Http.postFile({
    url: '/analyzer/admin/modules/fileupload/uploadfiles',
    data,
    responseType: 'blob',
  })
}

/* ai定制 */
// 渠道
export function channel_config(params) {
  return Http.get({
    url: '/cms/customization/channel_config',
    params,
  })
}

// 查询查找定制结果
export function getDZList(data) {
  return Http.postJson({
    url: '/cms/customization/query',
    data,
  })
}

// 定制详情
export function getAiDet(params) {
  return Http.get({
    url: '/cms/customization/get_id',
    params,
  })
}

// 定制列表导出
export function download_file(data) {
  return Http.download({
    url: '/cms/customization/download_file',
    data,
  })
}

/* 普通商品 */
// 下拉框类型
export function get_categories_options(params) {
  return Http.get({
    url: '/cms/ordinary_product/get_categories',
    params,
  })
}

// 查看普通商品详情
export function getProDet(params) {
  return Http.get({
    url: '/cms/ordinary_product/select_id',
    params,
  })
}

// 新增商品
export function addPro(data) {
  return Http.postJson({
    url: '/cms/ordinary_product/add',
    data,
  })
}

// 编辑商品
export function editPro(data) {
  return Http.postJson({
    url: '/cms/ordinary_product/edit',
    data,
  })
}

// 删除商品
export function delPro(params) {
  return Http.get({
    url: '/cms/ordinary_product/delete_id',
    params,
  })
}

// 分页查询商品
export function getPro(data) {
  return Http.postJson({
    url: '/cms/ordinary_product/queryPage',
    data,
  })
}

/* 功能性商品 */
// 获取类别（1级别和2级别）
export function get_categories(params) {
  return Http.get({
    url: '/cms/productSolution/get_categories',
    params,
  })
}

// 查询功能性商品
export function query_solution(data) {
  return Http.postJson({
    url: '/cms/productSolution/query_solution',
    data,
  })
}

// 通过Id查询功能商品
export function get_solution(id) {
  return Http.get({
    url: '/cms/productSolution/select_solution/' + id,
  })
}

// 更新和增加，根据id存在判断
export function add_update_solution(data) {
  return Http.postJson({
    url: '/cms/productSolution/add_update_solution',
    data,
  })
}

// 根据id删除
export function del_solution(id) {
  return Http.get({
    url: '/cms/productSolution/delete_solution/' + id,
  })
}

// 获取数据总览
export function get_data_overview(data) {
  return Http.postJson({
    url: '/cms/data_overview/get_data_overview',
    data,
  })
}

// 获取首页轮播图列表
export function get_banner_list(data) {
  return Http.get({
    url: '/cms/homepage_banners/list',
  })
}